import {} from "./avatar.types";

const initialState = {
  avatar: null,
};

export const avatarReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
